import { render, staticRenderFns } from "./PanelPaymentSelectionSimple.vue?vue&type=template&id=7830adb8&scoped=true&"
import script from "./PanelPaymentSelectionSimple.vue?vue&type=script&lang=js&"
export * from "./PanelPaymentSelectionSimple.vue?vue&type=script&lang=js&"
import style0 from "./PanelPaymentSelectionSimple.vue?vue&type=style&index=0&id=7830adb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7830adb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VMenu,VRow,VTooltip})
